export class ProviderOrderListType {
    static TODAY = 'today';
    static TOMORROW = 'tomorrow';
    static THIS_WEEK = 'this_week';
    static ALL = 'all';
    static ARCHIVED = 'archived';
}

Object.freeze(ProviderOrderListType);